/** A temporarilly shared namespace for both the API and Web packages.
 * @TODO: this should be moved to the `apps/api/features/media.ts#Media` namespace and exported to web */
export namespace media {
    export type MediaType = (typeof MEDIA_TYPES)[number];

    export const MEDIA_TYPES = [
        'activity/header',
        'activity/gallery',
        'activity/sheet',

        'activity_category/header',
        'activity_category/gallery',

        'catering/gallery',

        'partner/referral/invoice',
        'partner/referral/header',
        'partner/deal/invoice',
        'partner/agreement',

        'bizz/logo',
        'bizz/welcome',

        'document/invoice',
        'document/quotation',

        'user/profile',
    ] as const;

    /** PDFType is a subset of MediaType that represents PDFs */
    export const PDF_TYPES = [
        'activity/sheet',
        'partner/agreement',
    ] as const satisfies readonly MediaType[];
    export type PDFType = (typeof PDF_TYPES)[number];
}
